import { flowAsync } from '@gcc/nodash';
import { set, get, map } from 'lodash/fp';

import navigateToCart from '../navigateToCart';
import { copyConfiguration } from '../../api/designBuilder';
import { addConfigurationsToCart } from '../../api/thd';

export default flowAsync(
  map(async item => set(
    'itemProduct.configurationGuid',
    await copyConfiguration(
      get('itemProduct.configurationGuid', item),
      get('label', item),
    ),
    item,
  )),
  async promises => Promise.all(promises),
  map(item => ({
    configurationId: get('itemProduct.configurationGuid', item),
    skuNumber: get('itemProduct.skuNumber', item),
  })),
  addConfigurationsToCart,
  navigateToCart,
);
